import axios from 'axios';
import { message } from 'ant-design-vue';

// 创建axios实例
const service = axios.create({
  baseURL: window.appConfig.apiUrl, // api 的 base_url
  // timeout: 20000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && (config.headers.Authorization = token)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code && res.code !== 200) {
      // message.error(res.message);
      return Promise.reject('error');
    } else {
      return response.data;
    }
  },
  (error) => {
    if (error?.response?.data?.message) {
      message.error(error.response.data.message, 5);
    } else {
      message.error(error.message, 5);
    }

    return Promise.reject(error);
  }
);
// 响应拦截器
export default service;
